export enum ResetTypeEnum {
  reset = 'reset',
  activation = 'activation'
}
